import { useGetLocalizationText } from "_store/localization/selectors";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import Popup from "components/Popup/Popup";

export default function LoadingPopup() {
  const getLocalizationText = useGetLocalizationText();

  return (
    <Popup
      style={{
        display: "flex",
        flexDirection: "column",
        borderRadius: "0px",
        alignItems: "self-start",
        justifyContent: "start",
        padding: "10px",
        background: "white",
        overflow: "auto",
        overflowX: "hidden",
        maxHeight: "90%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "50px",
        }}
      >
        <LoadingSpinner />
        <div
          style={{
            marginBottom: "25px",
            fontSize: "24px",
            fontWeight: "400",
            lineHeight: "30px",
            letterSpacing: "0em",
            textAlign: "center",
          }}
        >
          {getLocalizationText("BioCode_Configuration_InProgress")}
        </div>
      </div>
    </Popup>
  );
}
